// @ts-nocheck

import dash_api from '../../support/dash_api';
import { ReduxAsyncAction } from '../../support/utils';

const ESPDomainValidation = new ReduxAsyncAction('ESP_DOMAIN_VALIDATION');
ESPDomainValidation.registerRequest(function (domain) {
  return dash_api.get(`/v1/domain/validate-aasa-and-ssl/${domain}`).then(({ data }) => data);
});

export const espDomainValidation = ESPDomainValidation.request;
export const ESP_DOMAIN_VALIDATION = ESPDomainValidation.constants;
